import { PipeTransform, Pipe, Injectable } from '@angular/core';
import { ActorIdentitiesController, ServicesByCategoryCodeController, DoctorsListController, DoctorAppointmentsByDoctorcodeContoller, FollicularScansBetweenDateController, FollicularPickUpsBetweenDateController, LongCodeTypeValueController, EmployeesByFacilityCodeController, CycleOocyteQualityBetweenDateController, CounsellingActivitiesByTimeController, ReadyForPickUpsBetweenDateController, IvfCycleMedicineByCodeController, IvfCycleTestByCodeController, PatientwiseLabReportsController, CycleSpermPreparationBetweenDateController, EmbryoGradesBetweenDateController, ReadyForTransferBetweenDateController, BillDetailsInfoController, X_BillHeaderController, OocyteMorphologyByCycleController, RefundDetailsController, ExpenseVouchersController, IahOrdersController, IahOrderItemsController, StoreLocationMaterialsController, MaterialConsumptionEntries2Controller, TradedDrugDetailViewController, ExternalDoctorsListController, RefundListController, AccessRightData, AccessRightsByRoleController, MaterialSpecsController, DoctorAppointmentsByDoctorcode2Contoller } from '../../models/actor/actor';
import { pipe } from 'rxjs';
import { CustomCodeValuesController_, CodeTypesController } from '../../models/master/mastermodel';


@Pipe({
  name: 'ActorIdentitiesFilter'
})

@Injectable()
export class ActorIdentitiesPipe implements PipeTransform {

  transform(value: ActorIdentitiesController[], filter: string): ActorIdentitiesController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: ActorIdentitiesController) =>
      app.CredentialType != null && app.CredentialType.toLocaleLowerCase().indexOf(filter) != -1

      || app.IssuingAuthority != null && app.IssuingAuthority.toLocaleLowerCase().indexOf(filter) != -1
      || app.IssuingAuthorityLongValue != null && app.IssuingAuthorityLongValue.toLocaleLowerCase().indexOf(filter) != -1
    ) : value;
  }

}

@Pipe({
  name: 'servicecategorypipe'
})

@Injectable()
export class ServiceCategoryPipe implements PipeTransform {

  transform(value: ServicesByCategoryCodeController[], filter: string): ServicesByCategoryCodeController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: ServicesByCategoryCodeController) =>
      app.Code != null && app.Code.toString().toLocaleLowerCase().indexOf(filter) != -1 ||
      app.ServiceName != null && app.ServiceName.toLocaleLowerCase().indexOf(filter) != -1 ||
      app.BasePrice != null && app.BasePrice.toString().toLocaleLowerCase().indexOf(filter) != -1

    ) : value;
  }

}

@Pipe({
  name: 'accessrightpipe'
})

@Injectable()
export class AccessRightPipe implements PipeTransform {

  transform(value: AccessRightsByRoleController[], filter: string): AccessRightsByRoleController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: AccessRightsByRoleController) =>
      app.FeatureName != null && app.FeatureName.toString().toLocaleLowerCase().indexOf(filter) != -1 ||
      app.FeatureDescription != null && app.FeatureDescription.toLocaleLowerCase().indexOf(filter) != -1


    ) : value;
  }

}

@Pipe({
  name: 'Doctorlistpipe'
})

@Injectable()
export class DoctorListPipe implements PipeTransform {

  transform(value: DoctorsListController[], filter: string): DoctorsListController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: DoctorsListController) =>
      app.DisplayName != null && app.DisplayName.toString().toLocaleLowerCase().indexOf(filter) != -1 ||
      app.Specialty != null && app.Specialty.toLocaleLowerCase().indexOf(filter) != -1


    ) : value;
  }

}
@Pipe({
  name: 'scanspipe'
})

@Injectable()
export class ScansPipe implements PipeTransform {

  transform(value: FollicularScansBetweenDateController[], filter: string): FollicularScansBetweenDateController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: FollicularScansBetweenDateController) =>

      app.FollicularGrowthOwnerName != null && app.FollicularGrowthOwnerName.toLocaleLowerCase().indexOf(filter) != -1


    ) : value;
  }

}
@Pipe({
  name: 'iahpipe'
})

@Injectable()
export class IahPipe implements PipeTransform {

  transform(value: IahOrdersController[], filter: string): IahOrdersController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: IahOrdersController) =>

      app.CustomerName != null && app.CustomerName.toLocaleLowerCase().indexOf(filter) != -1



    ) : value;
  }

}
@Pipe({
  name: 'itemsiahpipe'
})

@Injectable()
export class ItemsIahpipe implements PipeTransform {

  transform(value: IahOrderItemsController[], filter: string): IahOrderItemsController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: IahOrderItemsController) =>

      app.ItemName != null && app.ItemName.toLocaleLowerCase().indexOf(filter) != -1


    ) : value;
  }

}

@Pipe({
  name: 'approvallistpipe'
})

@Injectable()
export class Approvallistpipe implements PipeTransform {

  transform(value: RefundDetailsController[], filter: string): RefundDetailsController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: RefundDetailsController) =>

      app.PatientName != null && app.PatientName.toLocaleLowerCase().indexOf(filter) != -1 ||
      app.RefundStatus != null && app.RefundStatus.toLocaleLowerCase().indexOf(filter) != -1

    ) : value;
  }

}

@Pipe({
  name: 'providerpipe'
})

@Injectable()
export class Providerlistpipe implements PipeTransform {

  transform(value: DoctorsListController[], filter: string): DoctorsListController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: DoctorsListController) =>

      app.DisplayName != null && app.DisplayName.toLocaleLowerCase().indexOf(filter) != -1


    ) : value;
  }

}
@Pipe({
  name: 'externaldocpipe'
})

@Injectable()
export class Externallistpipe implements PipeTransform {

  transform(value: ExternalDoctorsListController[], filter: string): ExternalDoctorsListController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: ExternalDoctorsListController) =>

      app.DisplayName != null && app.DisplayName.toLocaleLowerCase().indexOf(filter) != -1


    ) : value;
  }

}

@Pipe({
  name: 'drugslistpipe'
})

@Injectable()
export class Drugslistpipe implements PipeTransform {

  transform(value: TradedDrugDetailViewController[], filter: string): TradedDrugDetailViewController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: TradedDrugDetailViewController) =>

      app.TradeName != null && app.TradeName.toLocaleLowerCase().indexOf(filter) != -1


    ) : value;
  }

}

@Pipe({
  name: 'refundslistpipe'
})

@Injectable()
export class Refundslistpipe implements PipeTransform {

  transform(value: RefundListController[], filter: string): RefundListController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: RefundListController) =>

      app.PatientName != null && app.PatientName.toLocaleLowerCase().indexOf(filter) != -1


    ) : value;
  }

}
@Pipe({
  name: 'storepipe'
})

@Injectable()
export class Storelistpipe implements PipeTransform {

  transform(value: StoreLocationMaterialsController[], filter: string): StoreLocationMaterialsController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: StoreLocationMaterialsController) =>

      app.Description != null && app.Description.toLocaleLowerCase().indexOf(filter) != -1


    ) : value;
  }

}
@Pipe({
  name: 'materialspecpipe'
})

@Injectable()
export class MaterialSpecpipe implements PipeTransform {

  transform(value: MaterialSpecsController[], filter: string): MaterialSpecsController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: MaterialSpecsController) =>

      app.MaterialName != null && app.MaterialName.toLocaleLowerCase().indexOf(filter) != -1 

    ) : value;
  }

}
@Pipe({
  name: 'expensevoucherpipe'
})

@Injectable()
export class ExpenseVoucherpipe implements PipeTransform {

  transform(value: ExpenseVouchersController[], filter: string): ExpenseVouchersController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: ExpenseVouchersController) =>

      app.VoucherNo != null && app.VoucherNo.toLocaleLowerCase().indexOf(filter) != -1 ||
      app.EmployeeName != null && app.EmployeeName.toLocaleLowerCase().indexOf(filter) != -1

    ) : value;
  }

}
@Pipe({
  name: 'consumptionentrypipe'
})

@Injectable()
export class ConsumptionEntrypipe implements PipeTransform {

  transform(value: MaterialConsumptionEntries2Controller[], filter: string): MaterialConsumptionEntries2Controller[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: MaterialConsumptionEntries2Controller) =>


      app.PatientName != null && app.PatientName.toLocaleLowerCase().indexOf(filter) != -1

    ) : value;
  }

}


@Pipe({
  name: 'testviewpipe'
})

@Injectable()
export class TestViewPipe implements PipeTransform {

  transform(value: PatientwiseLabReportsController[], filter: string): PatientwiseLabReportsController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: PatientwiseLabReportsController) =>

      app.TestName != null && app.TestName.toLocaleLowerCase().indexOf(filter) != -1


    ) : value;
  }

}
@Pipe({
  name: 'activitespipe'
})

@Injectable()
export class ActivitesPipe implements PipeTransform {

  transform(value: CounsellingActivitiesByTimeController[], filter: string): CounsellingActivitiesByTimeController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: CounsellingActivitiesByTimeController) =>

      app.ActivityName != null && app.ActivityName.toLocaleLowerCase().indexOf(filter) != -1 ||
      app.ActivityTypeName != null && app.ActivityTypeName.toLocaleLowerCase().indexOf(filter) != -1 ||
      app.Remarks != null && app.Remarks.toLocaleLowerCase().indexOf(filter) != -1

    ) : value;
  }

}
@Pipe({
  name: 'OocyteabPipe'
})

@Injectable()
export class OocyteAbPipe implements PipeTransform {

  transform(value: OocyteMorphologyByCycleController[], filter: string): OocyteMorphologyByCycleController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: OocyteMorphologyByCycleController) =>

      app.Morphology != null && app.Morphology.toLocaleLowerCase().indexOf(filter) != -1


    ) : value;
  }

}
@Pipe({
  name: 'medicinepipe'
})

@Injectable()
export class MedicinePipe implements PipeTransform {

  transform(value: IvfCycleMedicineByCodeController[], filter: string): IvfCycleMedicineByCodeController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: IvfCycleMedicineByCodeController) =>

      app.MedicineName != null && app.MedicineName.toLocaleLowerCase().indexOf(filter) != -1


    ) : value;
  }

}
@Pipe({
  name: 'testpipe'
})

@Injectable()
export class TestPipe implements PipeTransform {

  transform(value: IvfCycleTestByCodeController[], filter: string): IvfCycleTestByCodeController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: IvfCycleTestByCodeController) =>

      app.TestName != null && app.TestName.toLocaleLowerCase().indexOf(filter) != -1


    ) : value;
  }

}
@Pipe({
  name: 'pickpipe'
})

@Injectable()
export class PickPipe implements PipeTransform {

  transform(value: FollicularPickUpsBetweenDateController[], filter: string): FollicularPickUpsBetweenDateController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: FollicularPickUpsBetweenDateController) =>

      app.OwnerName != null && app.OwnerName.toLocaleLowerCase().indexOf(filter) != -1


    ) : value;
  }

}
@Pipe({
  name: 'inseminationpipe'
})

@Injectable()
export class InseminationPipe implements PipeTransform {

  transform(value: CycleSpermPreparationBetweenDateController[], filter: string): CycleSpermPreparationBetweenDateController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: CycleSpermPreparationBetweenDateController) =>

      app.OwnerName != null && app.OwnerName.toLocaleLowerCase().indexOf(filter) != -1


    ) : value;
  }

}
@Pipe({
  name: 'gradingpipe'
})

@Injectable()
export class GradingPipe implements PipeTransform {

  transform(value: EmbryoGradesBetweenDateController[], filter: string): EmbryoGradesBetweenDateController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: EmbryoGradesBetweenDateController) =>

      app.OwnerName != null && app.OwnerName.toLocaleLowerCase().indexOf(filter) != -1


    ) : value;
  }

}
@Pipe({
  name: 'Etpipe'
})

@Injectable()
export class EtPipe implements PipeTransform {

  transform(value: ReadyForTransferBetweenDateController[], filter: string): ReadyForTransferBetweenDateController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: ReadyForTransferBetweenDateController) =>

      app.OwnerName != null && app.OwnerName.toLocaleLowerCase().indexOf(filter) != -1


    ) : value;
  }

}
@Pipe({
  name: 'semanpipe'
})

@Injectable()
export class SemanPipe implements PipeTransform {

  transform(value: CycleSpermPreparationBetweenDateController[], filter: string): CycleSpermPreparationBetweenDateController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: CycleSpermPreparationBetweenDateController) =>

      app.OwnerName != null && app.OwnerName.toLocaleLowerCase().indexOf(filter) != -1


    ) : value;
  }

}
@Pipe({
  name: 'pregencyTrackerpipe'
})

@Injectable()
export class PregencyTrackerPipe implements PipeTransform {

  transform(value: ReadyForTransferBetweenDateController[], filter: string): ReadyForTransferBetweenDateController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: ReadyForTransferBetweenDateController) =>

      app.OwnerName != null && app.OwnerName.toLocaleLowerCase().indexOf(filter) != -1


    ) : value;
  }

}
@Pipe({
  name: 'pickpipe2'
})

@Injectable()
export class PickPipe2 implements PipeTransform {

  transform(value: ReadyForPickUpsBetweenDateController[], filter: string): ReadyForPickUpsBetweenDateController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: ReadyForPickUpsBetweenDateController) =>

      app.OwnerName != null && app.OwnerName.toLocaleLowerCase().indexOf(filter) != -1


    ) : value;
  }

}
@Pipe({
  name: 'Oocytepipe'
})

@Injectable()
export class OocytePipe implements PipeTransform {

  transform(value: CycleOocyteQualityBetweenDateController[], filter: string): CycleOocyteQualityBetweenDateController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: CycleOocyteQualityBetweenDateController) =>

      app.OwnerName != null && app.OwnerName.toLocaleLowerCase().indexOf(filter) != -1


    ) : value;
  }

}

@Pipe({
  name: 'CodeType'
})

@Injectable()
export class CodeTypePipeNew implements PipeTransform {

  transform(value: CodeTypesController[], filter: string): CodeTypesController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: CodeTypesController) =>

      app.Name != null && app.Name.toLocaleLowerCase().indexOf(filter) != -1


    ) : value;
  }

}
@Pipe({
  name: 'CodeValues'
})

@Injectable()
export class CodeValuesPipeNew implements PipeTransform {

  transform(value: LongCodeTypeValueController[], filter: string): LongCodeTypeValueController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: LongCodeTypeValueController) =>

      app.LongValue != null && app.LongValue.toLocaleLowerCase().indexOf(filter) != -1 ||

      app.ShortValue != null && app.ShortValue.toLocaleLowerCase().indexOf(filter) != -1

    ) : value;
  }

}


@Pipe({
  name: 'UsersList'
})

@Injectable()
export class UsersListPipe implements PipeTransform {

  transform(value: EmployeesByFacilityCodeController[], filter: string): EmployeesByFacilityCodeController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: EmployeesByFacilityCodeController) =>

      app.UserName != null && app.UserName.toLocaleLowerCase().indexOf(filter) != -1 ||

      app.DisplayName != null && app.DisplayName.toLocaleLowerCase().indexOf(filter) != -1

    ) : value;
  }

}
@Pipe({
  name: 'Patientlistpipe2'
})

@Injectable()
export class PatientListPipe2 implements PipeTransform {

  transform(value: DoctorAppointmentsByDoctorcode2Contoller[], filter: string): DoctorAppointmentsByDoctorcode2Contoller[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: DoctorAppointmentsByDoctorcode2Contoller) =>
      app.PatientFormattedCode != null && app.PatientFormattedCode.toString().toLocaleLowerCase().indexOf(filter) != -1 ||
      app.PatientName != null && app.PatientName.toLocaleLowerCase().indexOf(filter) != -1 ||
      app.Age != null && app.Age.toString().toLocaleLowerCase().indexOf(filter) != -1 ||
      app.Gender != null && app.Gender.toLocaleLowerCase().indexOf(filter) != -1 ||
      app.Telephone1 != null && app.Telephone1.toLocaleLowerCase().indexOf(filter) != -1


    ) : value;
  }

}

@Pipe({
  name: 'Patientlistpipe'
})

 @Injectable()
export class PatientListPipe implements PipeTransform {

  transform(value: DoctorAppointmentsByDoctorcodeContoller[], filter: string): DoctorAppointmentsByDoctorcodeContoller[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: DoctorAppointmentsByDoctorcodeContoller) =>
      app.PatientFormattedCode != null && app.PatientFormattedCode.toString().toLocaleLowerCase().indexOf(filter) != -1 ||
      app.PatientName != null && app.PatientName.toLocaleLowerCase().indexOf(filter) != -1 ||
      app.Age != null && app.Age.toString().toLocaleLowerCase().indexOf(filter) != -1 ||
      app.Gender != null && app.Gender.toLocaleLowerCase().indexOf(filter) != -1 ||
      app.Telephone1 != null && app.Telephone1.toLocaleLowerCase().indexOf(filter) != -1


    ) : value;
  }

}
@Pipe({
  name: 'Billingpipe'
})

@Injectable()
export class BillingPipe implements PipeTransform {

  transform(value: X_BillHeaderController[], filter: string): X_BillHeaderController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: X_BillHeaderController) =>
      app.PatientName != null && app.PatientName.toString().toLocaleLowerCase().indexOf(filter) != -1



    ) : value;
  }

}
@Pipe({
  name: 'Servicebillpipe'
})
@Injectable()
export class Servicebillpipe implements PipeTransform {
  transform(value: ServicesByCategoryCodeController[], filter: string): ServicesByCategoryCodeController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: ServicesByCategoryCodeController) =>
      app.ServiceName != null && app.ServiceName.toString().toLocaleLowerCase().indexOf(filter) != -1
    ) : value;
  }
}


@Pipe({
  name: 'ConsultantMappipe'
})
@Injectable()
export class ConsultantMapPipe implements PipeTransform {
  transform(value: CustomCodeValuesController_[], filter: string): CustomCodeValuesController_[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: CustomCodeValuesController_) =>
      app.DisplayName != null && app.DisplayName.toString().toLocaleLowerCase().indexOf(filter) != -1
    ) : value;
  }
}
